// // // // src/utils/constant.js
export const API_BASE_URL = "https://api.algosoftwere.in";
// export const API_BASE_URL="http://localhost:5000"